var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpingState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3633 0.942017H3.34961C1.69336 0.942017 0.349609 2.28516 0.349609 3.94202V20.942H5.66211V6.25452H15.0508V10.3654L17.7012 11.8951L20.3496 10.3654L20.3633 10.317V3.94202C20.3633 2.28516 19.0195 0.942017 17.3633 0.942017Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7012 13.7738L20.3496 12.244V14.8888L17.7012 16.4186L15.0508 14.8888V12.244L17.7012 13.7738Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7012 18.2972L20.3496 16.7675V19.4122L17.7012 20.942L15.0508 19.4122V16.7675L17.7012 18.2972Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpingState);
export default __webpack_public_path__ + "static/media/pumping-state.d2a4ceea74d73d707f45670cd59909cb.svg";
export { ForwardRef as ReactComponent };